// src/encounter/medication-add-field.tsx
// One field of the rail's add-medication form: the focus target for its save-time error (found by
// `data-field`) and the home of its inline message (DS HelperText, role="alert").
import type { ReactNode } from 'react';
import { HelperText } from '@scripsteam/scrips-signal-ds';
import type { MedicationAddField as FieldName } from './lib/medication-add-validation';

export interface MedicationAddFieldProps {
  name: FieldName;
  error?: string;
  children: ReactNode;
}

export function MedicationAddField({ name, error, children }: MedicationAddFieldProps) {
  return (
    <div data-field={name} className="min-w-0">
      {children}
      {error ? <HelperText tone="error" id={`med-add-${name}-error`}>{error}</HelperText> : null}
    </div>
  );
}
